var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{attrs:{"id":_vm.id,"label":_vm.label,"color":_vm.color,"value":_vm.value,"readonly":_vm.readonly,"messages":_vm.messages,"error-messages":_vm.errorMessages,"disabled":_vm.disabled,"hide-details":_vm.hideDetails},on:{"input":_vm.onHandleChangeValue}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }